import React from 'react';
import { contacts, content, settings } from '../content';
import { withPlural } from '../utils/plural';
import { ArrowRightIcon, CheckIcon, MailIcon } from './Icon';
// `.btn` is shared with the contacts page.
import '../styles/Sections.css';
import '../styles/OfferBar.css';

const { offer, projects, ui } = content;

/* Counted, not typed: the claim "N of them you can open right now" is the one
   sentence on this page a visitor can immediately disprove, so it is derived
   from the same list that renders the cards. */
const verifiable = projects.filter(
  (project) => (project.details?.links?.length ?? 0) > 0
).length;

/**
 * Sits above the project grid on the landing section. Cards show what was
 * built; this says what a visitor gets and what happens if they write —
 * the two things a grid of screenshots cannot answer. It carries the page's
 * `<h1>`, because the section title above it is a nav label, not an offer.
 */
const OfferBar = () => (
  <section className="offer">
    <div className="offer__body">
      <p
        className={`offer__eyebrow${
          settings.availableForWork ? ' offer__eyebrow--live' : ''
        }`}
      >
        {settings.availableForWork ? offer.availableEyebrow : offer.busyEyebrow}
      </p>
      <h1 className="offer__title">{offer.title}</h1>
      <p className="offer__text">{offer.text}</p>
      <p className="offer__proof">
        {offer.proof(withPlural(projects.length, ui.servicesPlural), verifiable)}
      </p>

      <ul className="offer__points">
        {offer.points.map((point) => (
          <li key={point} className="offer__point">
            <CheckIcon size={14} />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>

    <div className="offer__aside">
      <div className="offer__actions">
        <a
          className="btn btn--primary"
          href={contacts.telegram}
          target="_blank"
          rel="noreferrer"
        >
          {offer.primary}
          <ArrowRightIcon size={15} />
        </a>
        <a className="btn btn--ghost" href={`mailto:${contacts.email}`}>
          <MailIcon size={15} />
          {offer.secondary}
        </a>
      </div>
      <p className="offer__note">{offer.note}</p>
    </div>
  </section>
);

export default OfferBar;
